import { FormData, ProductData, SavedFormData, SavedFormDataKey, SavedOrderDataKey, SavedProductData, SavedProductDataKey } from "./stolarz_form_types";

export function readFormData(): null | SavedFormData {
    let data = localStorage.getItem(SavedFormDataKey);
    if (data) {
        try {
            const saved = JSON.parse(data) as SavedFormData;
            return saved
        } catch (err) {
            console.log(err);
        }
    }
    return null;

}

export function writeFormData(values: FormData) {
    let savedForm: SavedFormData = {
        name: values.name,
        email: values.email,
        address: values.address,
        postalCode: values.postalCode,
        city: values.city,
        nip: values.nip,
        summary: values.summary,
    };
    localStorage.setItem(SavedFormDataKey, JSON.stringify(savedForm));
}

export function readProductData(): SavedProductData[] | null {
    const savedDataprodicts = localStorage.getItem(SavedProductDataKey);
    if (savedDataprodicts) {
        try {
            const saved: SavedProductData[] = JSON.parse(savedDataprodicts) as SavedProductData[];
            return saved;
        } catch (err) {
            console.log(err);
        }
    }
    return null;
}

export function writeProductData(products: SavedProductData[]) {
    localStorage.setItem(SavedProductDataKey, JSON.stringify(products));
}

export function readOrderData(): { [id: string]: ProductData[]; } | null {
    const savedDataOrders = localStorage.getItem(SavedOrderDataKey);
    if (savedDataOrders) {
        try {
            const saved = JSON.parse(savedDataOrders);
            return saved;
        } catch (err) {
            console.log(err);
        }
    }
    return null;
}

export function writeOrderData(orders: { [id: string]: ProductData[]; }) {
    localStorage.setItem(SavedOrderDataKey, JSON.stringify(orders));
}